"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveFromWishlistCommand = void 0;
class RemoveFromWishlistCommand {
    constructor(userId, studyId, expectedState, isLocal) {
        this.userId = userId;
        this.studyId = studyId;
        this.expectedState = expectedState;
        this.isLocal = isLocal;
    }
}
exports.RemoveFromWishlistCommand = RemoveFromWishlistCommand;
